module.exports = __webpack_public_path__ + "img/order-icon.562eaad9.png";